import React from 'react';
import * as S from './styles';

const Slide2: React.FC = () => {
  return (
    <S.Container>
      <S.Image />
      <S.Subtitle>
        Sutiã, Intimissimi,
        <br /> R$ 199. Penhoar, acervo Casa Juisi. Brincos e choker, preços sob
        consulta, sandálias,
        <br /> R$ 7.500, tudo Dolce & Gabbana. Meia calça, Calzedonia, R$ 109.
      </S.Subtitle>
    </S.Container>
  );
};

export { Slide2 };
